import { inquiryBCADD } from 'data';

// initiate binding for direct debit partner
export default async function inquiryBCA(payment_provider, auth) {
    return inquiryBCADD(payment_provider, auth);
}
